var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subtitle"},[_c('h5',[_vm._t("default",function(){return [_vm._v("Warning!! Insert subtitle here")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }